/* tslint:disable */

declare var Object: any;
export interface RolInterface {
  "idrol": number;
  "rol": string;
  "activo": boolean;
  "idrolmongo"?: string;
  "descripcion"?: string;
}

export class Rol implements RolInterface {
  "idrol": number;
  "rol": string;
  "activo": boolean;
  "idrolmongo": string;
  "descripcion": string;
  constructor(data?: RolInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Rol`.
   */
  public static getModelName() {
    return "Rol";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Rol for dynamic purposes.
  **/
  public static factory(data: RolInterface): Rol{
    return new Rol(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Rol',
      plural: 'Rols',
      path: 'Rols',
      idName: 'idrol',
      properties: {
        "idrol": {
          name: 'idrol',
          type: 'number'
        },
        "rol": {
          name: 'rol',
          type: 'string'
        },
        "activo": {
          name: 'activo',
          type: 'boolean'
        },
        "idrolmongo": {
          name: 'idrolmongo',
          type: 'string'
        },
        "descripcion": {
          name: 'descripcion',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/lbsdk/models/Rol.ts